module.exports = __webpack_public_path__ + "img/SEGURIFY_GIF_QUALITAS.e4c184fe.gif";